import { render, staticRenderFns } from "./TableRefundForm.vue?vue&type=template&id=06551a75"
import script from "./TableRefundForm.vue?vue&type=script&lang=js"
export * from "./TableRefundForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports